import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

const headingModule = () => {

    const headings = document.querySelectorAll('.js-heading');

    headings.forEach(heading => {

        const splitText = new SplitText(heading, {
            type: "words",
            mask: "words",
        });

        const words = splitText.words;

        gsap.set(heading, { opacity: 1 });

        ScrollTrigger.matchMedia({
            "(pointer: fine)": () => {

                gsap.set(words, {
                    yPercent: 120,
                });

                words.forEach((word, index) => {

                    word.classList.add('py-5', 'pr-1');
                    word.parentElement.classList.add('-my-5', '-mr-1');

                    gsap.to(word, {
                        duration: 1,
                        yPercent: 0,
                        ease: 'power4.inOut',
                        delay: index * 0.04,
                        scrollTrigger: {
                            trigger: heading,
                            start: 'top 95%',
                            end: 'bottom bottom',
                        },

                    });

                });

            },
            "(pointer: coarse)": () => {
                const tl = gsap.timeline();

                tl.to(words, {
                    yPercent: 0,
                });
            }
        });


    });

}

export { headingModule };